import { MenuItemsModel } from '@core/menu/menu.model';
import { RouteEntity } from '@core/router/route.entity';
import { PrivilegesModules } from '@core/privileges/privileges-modules';
import { marker } from '@colsen1991/ngx-translate-extract-marker';


export const submenu: MenuItemsModel[] = [
    {
        mdId: 1,
        mdName: marker('modules.rejected.head'),
        url: RouteEntity.Root + RouteEntity.Rejected,
        objName: [PrivilegesModules.AntifraudControl],
    },
    {
        mdId: 2,
        mdName: marker('modules.suspicious.head'),
        url: RouteEntity.Root + RouteEntity.Suspicious,
        objName: [PrivilegesModules.AntifraudControl],
    },
    {
        mdId: 3,
        mdName: marker('global.labels.ids'),
        url: RouteEntity.Root + RouteEntity.Ids,
        objName: [PrivilegesModules.AntifraudControl],
    },
    {
        mdId: 4,
        mdName: marker('modules.settings.head'),
        url: RouteEntity.Root + RouteEntity.Reasons,
        objName: [PrivilegesModules.AntifraudControl],
    },
];
